import React from "react";
import { Navigate, Route } from "react-router-dom";
import { INVENTORY_ROLES } from "../constants/roles";
import AppShell from "../layout/AppShell";
import RequireRoles from "../layout/RequireRoles";
import { INVENTORY_NAV } from "./nav-config";
import InventoryCataloguePage from "./pages/catalogue";
import ProcurementPage from "./pages/procurement";
import ProcurementNewPage from "./pages/procurement/new";
import ProcurementReorderPage from "./pages/procurement/reorder";
import PurchaseOrdersPage from "./pages/procurement/purchase-orders";
import PurchaseOrderDetailPage from "./pages/procurement/purchase-orders/detail";
// Users + User Details — the legacy /users and /user/:id screens, mounted unchanged in
// every console. The users table links to `<current path>/:id`, so a row click stays in
// this console instead of jumping to the legacy /user/:id route.
import { Users } from "../../pages/users";
import UserDetails from "../../pages/user-details";
// GLP-1 Dashboard — the legacy /glp1-dashboard page, mounted unchanged.
// API: GET /glp1Dashboard/admin/orders (+ POST /delivery/markDelivered/:id from its rows).
import GLP1Dashboard from "../../pages/glp1-dashboard";

// Inventory Console — a top-level console at /v2/inventory/*, sibling of ops, pharmacy,
// sales, finance and logistics.
//
// Procurement is the landing view: it is the work queue. Its New/Reorder/Overall slices are
// three views of ONE calculation (see ProcurementView.jsx) reached via an in-page tab strip,
// which is why they are routes but not sidebar entries.
//
// Old /v2/pharmacy/inventory and /v2/pharmacy/procurement URLs redirect here — see
// src/v2/routes.jsx.
export const INVENTORY_ROUTES = (
    <Route path="/v2/inventory" element={<AppShell nav={INVENTORY_NAV} />}>
        <Route index element={<Navigate to="procurement" replace />} />
        <Route
            path="catalogue"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <InventoryCataloguePage />
                </RequireRoles>
            }
        />
        <Route
            path="procurement"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <ProcurementPage />
                </RequireRoles>
            }
        />
        <Route
            path="procurement/new"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <ProcurementNewPage />
                </RequireRoles>
            }
        />
        <Route
            path="procurement/reorder"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <ProcurementReorderPage />
                </RequireRoles>
            }
        />
        <Route
            path="procurement/purchase-orders"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <PurchaseOrdersPage />
                </RequireRoles>
            }
        />
        <Route
            path="procurement/purchase-orders/:id"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <PurchaseOrderDetailPage />
                </RequireRoles>
            }
        />
        <Route
            path="glp1"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <GLP1Dashboard />
                </RequireRoles>
            }
        />
        <Route
            path="users"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <Users />
                </RequireRoles>
            }
        />
        <Route
            path="users/:id"
            element={
                <RequireRoles roles={INVENTORY_ROLES}>
                    <UserDetails />
                </RequireRoles>
            }
        />
    </Route>
);
